export default __webpack_public_path__ + "static/media/LC.9971d8cf.ico";